// extracted by mini-css-extract-plugin
export default {"container":"how-to-use_container__og66M"};